import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { toast } from 'react-toastify';
import { Loader } from '../shared-components';
import { socialIcons } from '../../styles/icons';
import { GaContext } from '../../googleAnalyticsContext/GaContext';
import ReactGA from 'react-ga';
import { withFirebase } from '../../Firebase';
import FacebookConnect from '../shared-components/FacebookConnect/FacebookConnect';
import {
  FACEBOOK_CONNECTION_SUCCESS_MSG,
  FACEBOOK_DISCONNECT_SUCCESS_MSG,
  FACEBOOK_SOCIAL_ICOSNS_KEY,
  FACEBOOK_SOURCE_NAME, SOCIAL_MEDIA_SOURCE_TYPE, SOURCE_NAMES_SEPARATOR,
  FORUM_PAGE_NAME_LABEL,
  CHECKED_CHECKBOX_CLASS, UNCHECKED_CHECKBOX_CLASS, INDETERMINATE_CHECKBOX_CLASS,
  TIKTOK_SOURCE_NAME, INSTAGRAM_SOURCE_NAME, YOUTUBE_SOURCE_NAME,
  REDDIT_SOURCE_NAME
} from './redux/constants';
import { t } from 'i18next';
import {
  SOURCES_I18N_PREFIX as MY_I18N_PREFIX,
  SOURCES_I18N_KEYS as MY_I18N_KEYS
} from './constants/i18n/Sourcesi18nConstants';
import { getUserEmailFromLocalStorage } from '../../Firebase/localStorageForUserInfo';
import { 
  getLoginRedirectUrl,
  getFeedIconForFacebook, 
  getFeedIconForInstagram,
  getFeedIconForTiktok,
  getFeedIconForYoutube,
  getFeedIconForForum,
  getDefaultRedditIcon,
  getDefaultXIcon
} from '../home/sharedFunctions';
import { FORUM_KEY } from '../home/components/constants/FeedCommentConstants';
import { SOURCE_NAME_TWITTER } from '../home/redux/constants';
import { apiEndPoints } from '../../common/globalConstants';
import http from '../../common/http';
import { areTruescopeSourcesEnabled } from '../../common/globalUtils';


class Input extends Component {
  render() {
    return <input {...this.props} />;
  }
}
export class Sources extends Component {
  static propTypes = {
    sources: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      allSources: [],
      isSourceUpdating: false,
      isDeletingFacebookConnection: false,
      isUpdatingFacebookConnection: false,
      isCheckingFacebookConnection: false,
      isFacebookConnected: false,
      isFacebookCheckboxChecked: false,
      isfFacebookCheckboxIndeterminate: false,
      facebookCheckboxClass: null,
      showFacebookDropdown: false,
      isTruescopeForumCheckboxChecked: false,
      isTruescopeForumCheckboxIndeterminate: false,
      truescopeForumCheckboxClass: null,
      showTruescopeForumDropdown: false
    };
  }

  getI18nText(textKey){
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  handleDeleteFaceookConnection = () => {
    this.setState({
      isDeletingFacebookConnection: true
    }, () => {
      this.props.actions.deleteFacebookConnection({
        resonance_user_email: getUserEmailFromLocalStorage()
      });
    });
  }

  setFacebookConnectionStateWhenConnectingToFacebook = (response) => {
    this.setState({
       isUpdatingFacebookConnection: true,
       facebookUserId: response.id,
       facebookAccessToken: response.accessToken
    });
  }

  setSourceStatus = sourceName => {
    const { allSources } = this.state;
    const updateSource = allSources.filter(source => source.sourceName === sourceName)[0];
    const updatedSource = allSources.map(source => {
      if (source.sourceName.toLowerCase() === sourceName.toLowerCase())
      {
        source.selected = !source.selected;
        this._logSourceSelectionChangeToGoogleAnalytics(source);
      }
      return source;
    });
    this.setState(
      {
        allSources: [...updatedSource],
        isSourceUpdating: true,
      },
      () => {
        this.props.actions.updateSelectedSourceStatus(updateSource);
      },
    );
  };

  _logSourceSelectionChangeToGoogleAnalytics(source) {
    if (source.selected)
    {
      ReactGA.event(
        {
          category :'source' ,
          action : `${source.sourceName} was selected by user with id ${this.props.cookies.cookies.userMeta}`
        }
      )
    }
    else
    {
      ReactGA.event(
        {
          category :'source' ,
          action : `${source.sourceName} was unselected by user with id ${this.props.cookies.cookies.userMeta}`
        }
      )
    }
  }

  navigateBack = () => {
    this.props.history.goBack();
  };
  static contextType = GaContext;
  componentDidMount() {
    
    const {ReactGA} = this.context;
    ReactGA.pageview('/dashboard/sources');

    const checkAuthTokenRequest = http.get(apiEndPoints.authentication.CHECK_TOKEN);
    checkAuthTokenRequest.then(
      response => {
        const { retrieveSources } = this.props.actions;
        retrieveSources();

        this._checkFacebookConnectionWhenFirebaseUserInfoIsAvailable();
        this._updateFacebookCheckboxStateIfNeeded();
        this._updateTruescopeForumCheckboxStateIfNeeded();
      },
      error => {
        this.props.history.push(getLoginRedirectUrl());
        return false;
      },
    );
  }

  _checkFacebookConnectionWhenFirebaseUserInfoIsAvailable() {
    const { checkFacebookConnection } = this.props.actions;
    const userEmail                   = getUserEmailFromLocalStorage();
    if (! userEmail) {
      this.props.history.push(getLoginRedirectUrl());
      return false;
    }
    else {
      this.setState({
        isCheckingFacebookConnection: true
      }, () => {
        checkFacebookConnection({
          resonance_user_email: userEmail
        });
      });
    }
  }

  componentWillUnmount() {
    this.setState({
      allSources: [],
    });
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (
      props.sources.allAvailableSources &&
      props.sources.allAvailableSources.length &&
      !this.state.isSourceUpdating &&
      JSON.stringify(props.sources.allAvailableSources) !== JSON.stringify(this.state.allSources)
    ) {
      props.actions.updateAvailableSources(props.sources.allAvailableSources);
      this.setState({ allSources: [...props.sources.allAvailableSources] });
    }
    if (props.sources.update_sources_success && this.state.isSourceUpdating) {
      toast.success(' Sources selection has been updated!');
      this.setState({
        isSourceUpdating: false,
      });
    }
    if (props.sources.update_sources_error && this.state.isSourceUpdating) {
      toast.error(' Sources selection has not been updated!');
      this.setState({
        isSourceUpdating: false,
      });
    }
    this._updateTruescopeForumCheckboxStateIfNeeded();
    this._updateFacebookCheckboxStateIfNeeded();
    this._setFacebookConnectionStateIfConnectionUpdated(props);
    this._setFacebookConnectionStateIfConnectionDeleted(props);
    this._setFacebookConnectionStateIfConnectionChecked(props);
  }

  _updateTruescopeForumCheckboxStateIfNeeded() {
    const truescopeForumSources = this._getAllTruescopeForumSourcesFromState();
    let truescopeForumsSelectedCount = 0;
    for (const truescopeForumSource of truescopeForumSources) {
      if (truescopeForumSource.selected) {
        truescopeForumsSelectedCount += 1;
      }
    }
    if (this._areAllTruescopeForumsSelected(truescopeForumsSelectedCount,truescopeForumSources)) {
      this.setState({
        isTruescopeForumCheckboxChecked: true,
        isTruescopeForumCheckboxIndeterminate: false,
        truescopeForumCheckboxClass: CHECKED_CHECKBOX_CLASS
      });
    }
    else if (this._areNoneOfTheTruescopeForumsSelected(truescopeForumsSelectedCount)) {
      this.setState({
        isTruescopeForumCheckboxChecked: false,
        isTruescopeForumCheckboxIndeterminate: false,
        truescopeForumCheckboxClass: UNCHECKED_CHECKBOX_CLASS
      });
    }
    else {
      this.setState({
        isTruescopeForumCheckboxChecked: false,
        isTruescopeForumCheckboxIndeterminate: true,
        truescopeForumCheckboxClass: INDETERMINATE_CHECKBOX_CLASS
      });
    }
  }

  _areAllTruescopeForumsSelected(truescopeForumsSelectedCount,truescopeForumSources) {
    return truescopeForumsSelectedCount === truescopeForumSources.length;
  }

  _areNoneOfTheTruescopeForumsSelected(truescopeForumsSelectedCount) {
    return truescopeForumsSelectedCount === 0;
  }
  

  _updateFacebookCheckboxStateIfNeeded() {
    const facebookPageSourcesData = this._getAllFacebookPageSourcesFromState();
    let facebookPagesSelectedCount = 0;
    for (const facebookPageSourceData of facebookPageSourcesData) {
      if (facebookPageSourceData.selected) {
        facebookPagesSelectedCount += 1;
      }
    }
    if (this._areAllFacebookPagesSelected(facebookPagesSelectedCount,facebookPageSourcesData)) {
      this.setState({
        isFacebookCheckboxChecked: true,
        isfFacebookCheckboxIndeterminate: false,
        facebookCheckboxClass: CHECKED_CHECKBOX_CLASS
      });
    }
    else if (this._areNoneOfTheFacebookPagesSelected(facebookPagesSelectedCount)) {
      this.setState({
        isFacebookCheckboxChecked: false,
        isfFacebookCheckboxIndeterminate: false,
        facebookCheckboxClass: UNCHECKED_CHECKBOX_CLASS
      });
    }
    else {
      this.setState({
        isFacebookCheckboxChecked: false,
        isfFacebookCheckboxIndeterminate: true,
        facebookCheckboxClass: INDETERMINATE_CHECKBOX_CLASS
      });
    }
  }

  _areAllFacebookPagesSelected(facebookPagesSelectedCount,facebookPageSourcesData) {
    return facebookPagesSelectedCount === facebookPageSourcesData.length;
  }

  _areNoneOfTheFacebookPagesSelected(facebookPagesSelectedCount) {
    return facebookPagesSelectedCount === 0;
  }
 
   _setFacebookConnectionStateIfConnectionUpdated(props) {
     if (this.state.isUpdatingFacebookConnection && props.sources.update_facebook_connection_success) {
       this.setState({
         isUpdatingFacebookConnection: false,
         isFacebookConnected: true
       }, () => {
         toast.success(FACEBOOK_CONNECTION_SUCCESS_MSG);
       });
       }
     }
   
   _setFacebookConnectionStateIfConnectionDeleted(props) {
     if (this.state.isDeletingFacebookConnection && props.sources.delete_facebook_connection_success) {
       this.setState({
         isDeletingFacebookConnection: false,
         isFacebookConnected: false
       }, () => {
         toast.success(FACEBOOK_DISCONNECT_SUCCESS_MSG);
       });
     }
   }
 
   _setFacebookConnectionStateIfConnectionChecked(props) {
     if (this.state.isCheckingFacebookConnection && props.sources.check_facebook_connection_success) {
       this.setState({
         isCheckingFacebookConnection: false,
         isFacebookConnected: props.sources.check_facebook_connection_result
       });
     }
   }


  handleFacebookCheckboxChanged = () => {
    const  facebookPageSourcesData = this._getAllFacebookPageSourcesFromState();
    const sourceNamesToUpdate = facebookPageSourcesData.map(source => {
      return source.sourceName;
    });

    if (this._isFacebookCheckboxUnchecked()) {
      const newAllSourcesState = this._getAllSourcesFromStateWhereFacebookPageSourcesUpdatedTo(true);
      this.setState(
        {
          allSources: [...newAllSourcesState],
          isSourceUpdating: true,
          isFacebookCheckboxChecked: true,
          isfFacebookCheckboxIndeterminate: true
        },
        () => {
          this.props.actions.updateSelectedSourceStatus({
            sourceName: sourceNamesToUpdate.join(SOURCE_NAMES_SEPARATOR),
            selected: true
          });
        },
      );
    }
    else {
      const newAllSourcesState = this._getAllSourcesFromStateWhereFacebookPageSourcesUpdatedTo(false);
      this.setState(
        {
          allSources: [...newAllSourcesState],
          isSourceUpdating: true,
          isFacebookCheckboxChecked: false,
          isfFacebookCheckboxIndeterminate: false
        },
        () => {
          this.props.actions.updateSelectedSourceStatus({
            sourceName: sourceNamesToUpdate.join(SOURCE_NAMES_SEPARATOR),
            selected: false
          });
        },
      );
    }
  };

  _isFacebookCheckboxUnchecked() {
    const {isFacebookCheckboxChecked, isfFacebookCheckboxIndeterminate} = this.state;
    return !isFacebookCheckboxChecked && !isfFacebookCheckboxIndeterminate;
  }

  _getAllSourcesFromStateWhereFacebookPageSourcesUpdatedTo(isSelected) {
    return this.state.allSources.map(source => {
      if (this._isSourceAFacebookPage(source)) {
        source.selected = isSelected;
        this._logSourceSelectionChangeToGoogleAnalytics(source);
      }
      return source;
    });
  }

  handleTruescopeForumCheckboxChanged = () => {
    const truescopeForumSources = this._getAllTruescopeForumSourcesFromState();
    const sourceNamesToUpdate = truescopeForumSources.map(source => {
      return source.sourceName;
    });

    if (this._isTruescopeForumCheckboxUnchecked()) {
      const newAllSourcesState = this._getAllSourcesFromStateWhereTruescopeForumSourcesUpdatedTo(true);
      this.setState(
        {
          allSources: [...newAllSourcesState],
          isSourceUpdating: true,
          isTruescopeForumCheckboxChecked: true,
          isTruescopeForumCheckboxIndeterminate: true
        },
        () => {
          this.props.actions.updateSelectedSourceStatus({
            sourceName: sourceNamesToUpdate.join(SOURCE_NAMES_SEPARATOR),
            selected: true
          });
        },
      );
    }
    else {
      const newAllSourcesState = this._getAllSourcesFromStateWhereTruescopeForumSourcesUpdatedTo(false);
      this.setState(
        {
          allSources: [...newAllSourcesState],
          isSourceUpdating: true,
          isTruescopeForumCheckboxChecked: false,
          isTruescopeForumCheckboxIndeterminate: false
        },
        () => {
          this.props.actions.updateSelectedSourceStatus({
            sourceName: sourceNamesToUpdate.join(SOURCE_NAMES_SEPARATOR),
            selected: false
          });
        },
      );
    }
  };

  _isTruescopeForumCheckboxUnchecked() {
    const {isTruescopeForumCheckboxChecked, isTruescopeForumCheckboxIndeterminate} = this.state;
    return !isTruescopeForumCheckboxChecked && !isTruescopeForumCheckboxIndeterminate;
  }

  _getAllSourcesFromStateWhereTruescopeForumSourcesUpdatedTo(isSelected) {
    return this.state.allSources.map(source => {
      if (this._isSourceATruescopeForum(source)) {
        source.selected = isSelected;
        this._logSourceSelectionChangeToGoogleAnalytics(source);
      }
      return source;
    });
  }

  _getAllFacebookPageSourcesFromState() {
    return this.state.allSources.filter(
      source => this._isSourceAFacebookPage(source)
    );
  }
  
  _isSourceAFacebookPage(source) {
    return source.sourceName.toLowerCase().includes(FACEBOOK_SOURCE_NAME) && source.sourceName.toLowerCase() !== FACEBOOK_SOURCE_NAME;
  }

  _getAllTruescopeForumSourcesFromState() {
    return this.state.allSources.filter(
      source => this._isSourceATruescopeForum(source)
    );
  }

  _isSourceATruescopeForum(source) {
    return source.sourceName.toLowerCase().includes(FORUM_PAGE_NAME_LABEL);
  }

  _isSourceAFacebookSourceOrATruescopeForum(sourceName) {
    return sourceName.toLowerCase().includes(FACEBOOK_SOURCE_NAME) || sourceName.toLowerCase().includes(FORUM_PAGE_NAME_LABEL)
  }

  toggleShowFacebookDropdown= () => {  
    this.setState(prevState => {
      return { showFacebookDropdown: !prevState.showFacebookDropdown };
    });
  }

  toggleShowTruescopeForumDropdown= () => {  
    this.setState(prevState => {
      return { showTruescopeForumDropdown: !prevState.showTruescopeForumDropdown };
    });
  }

  _getFeedIcon = (sourceName) => {
    if (sourceName.toLowerCase().includes(FACEBOOK_SOURCE_NAME)) {
      return getFeedIconForFacebook(sourceName);
    }
    else if (sourceName.toLowerCase() == YOUTUBE_SOURCE_NAME){
      return getFeedIconForYoutube()
    }
    else if (sourceName.toLowerCase() == REDDIT_SOURCE_NAME){
      return getDefaultRedditIcon()
    }
    else if (sourceName.toLowerCase() == SOURCE_NAME_TWITTER){
      return getDefaultXIcon()
    }
    else if (sourceName.toLowerCase().includes(INSTAGRAM_SOURCE_NAME)){
      return getFeedIconForInstagram();
    }
    else if (sourceName.toLowerCase().includes(TIKTOK_SOURCE_NAME)){
      return getFeedIconForTiktok();
    }
    else if (sourceName.toLowerCase().includes(FORUM_KEY)){
      return getFeedIconForForum(sourceName);
    }
    else {
      return sourceName.toLowerCase();
    }
  }

  render() {
    let allSources = [];
    allSources.push({
      sourceType: 'Social Media',
      sourcesData: this.state.allSources.filter(
        source => source.sourceType.toLowerCase() === SOCIAL_MEDIA_SOURCE_TYPE
      ),
      facebookPagesSourceData: this._getAllFacebookPageSourcesFromState(),
      truescopeForumSources: this._getAllTruescopeForumSourcesFromState(),
      nonFacebookOrTruescopeForumSources: this.state.allSources.filter(
        source => !this._isSourceAFacebookSourceOrATruescopeForum(source.sourceName)
      )
    });
    const {
      isFacebookConnected,
      showFacebookDropdown,
      showTruescopeForumDropdown
    } = this.state;

    return (
      <div className="sources-container">
        <div className="main-container">
          {allSources.length > 0 &&
            allSources.map((sources, _) => (
              <div className="sub-container" key={"container"}>
                <div className="source-content">
                  <div className="source-inner-content">
                    <h6 className="sub-text">{sources.sourceType}</h6>
                    
                    <div className="source-dropdown-header-container">
                      <div className="select-item" >
                        <button 
                          onClick={() => this.handleFacebookCheckboxChanged()}
                          className={`dropdown-source-header-label facebook-checkbox-wrapper-span ${this.state.isFacebookConnected ? '' : 'disabled'}`}
                        >
                          <Input
                            className={`dropdown-header-checkbox ${this.state.facebookCheckboxClass}`}
                            id="facebookCheckbox"
                            disabled={! this.state.isFacebookConnected}
                            type="checkbox"
                            value="facebook"
                          />
                          
                          <label htmlFor="Facebook">
                            <img src={this._getFeedIcon(FACEBOOK_SOURCE_NAME)} alt=""/>
                            {this.getI18nText(MY_I18N_KEYS.facebook_dropdown_header_label)}
                          </label>
                        </button>
                        <div className="connection-status">
                          <span className="manage-connection">
                            {isFacebookConnected ? (
                              <span onClick={this.handleDeleteFaceookConnection} className="facebook-connection-btn">
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: socialIcons[FACEBOOK_SOCIAL_ICOSNS_KEY]
                                    }}
                                  />
                                    {this.getI18nText(MY_I18N_KEYS.facebook_disconnect_button_label)}
                                  </span>
                            ) : (
                              <FacebookConnect
                                setFacebookConnectionStateWhenConnectingToFacebook={this.setFacebookConnectionStateWhenConnectingToFacebook}
                              />
                            )}
                            <span className="connection-btn">
                              <a href="https://www.resonancesocial.com/privacy-policy" target="_blank">(Privacy Policy)</a>
                            </span>
                          </span>
                        </div>
                        <button 
                          onClick={() => this.toggleShowFacebookDropdown()}
                          className="dropdown-button"
                        >
                          <i className={`la la-${showFacebookDropdown ? 'minus' :'plus'}`} />
                        </button>
                      </div>

                      {showFacebookDropdown && (
                        <div className="dropdown-source-pages-container">
                          {!sources.sourcesData.length && <Loader />}
                          {sources.facebookPagesSourceData.length > 0 &&
                            sources.facebookPagesSourceData.map((sourceData, index) => (
                              <div className="select-item"  key={'facebook_' + index}>
                                <Input
                                  className="styled-checkbox"
                                  id={sourceData.sourceName}
                                  disabled={! this.state.isFacebookConnected}
                                  type="checkbox"
                                  onChange={() => this.setSourceStatus(sourceData.sourceName)}
                                  checked={sourceData.selected}
                                  value={sourceData.sourceName}
                                />
                                
                                <label htmlFor={sourceData.sourceName}>
                                  <img src={this._getFeedIcon(sourceData.sourceName)} alt=""/>
                                  {sourceData.sourceName}
                                </label>
                              </div>
                            ))
                          }
                        </div>
                      )}
                    </div>

                    {sources.nonFacebookOrTruescopeForumSources.length > 0 &&
                      sources.nonFacebookOrTruescopeForumSources.map((sourceData, index) => (
                        <div className="source-dropdown-header-container" key={'othersources_' + index}>
                          <div className="select-item" key={'othersources_item_' + index}>
                            <Input
                              className="styled-checkbox"
                              id={sourceData.sourceName}
                              type="checkbox"
                              onChange={() => this.setSourceStatus(sourceData.sourceName)}
                              checked={sourceData.selected}
                              value={sourceData.sourceName}
                            />
                            <label htmlFor={sourceData.sourceName}>
                              <img 
                                src={this._getFeedIcon(sourceData.sourceName)} 
                                alt=""
                                className={sourceData.sourceName.toLowerCase().includes(INSTAGRAM_SOURCE_NAME) ? "instagram-icon" : ""}
                              />
                              {sourceData.sourceName}
                            </label>
                          </div>
                        </div>
                      ))
                    }

                    {areTruescopeSourcesEnabled() && (<div className="source-dropdown-header-container">
                      <div className="select-item">
                        <button 
                          onClick={() => this.handleTruescopeForumCheckboxChanged()}
                          className={"dropdown-source-header-label"}
                        >
                          <Input
                            className={`dropdown-header-checkbox ${this.state.truescopeForumCheckboxClass}`}
                            id="truescopeForumsCheckbox"
                            type="checkbox"
                            value="truescopeForums"
                          />
                          <label htmlFor="truescopeForums">
                            <img src={this._getFeedIcon(FORUM_KEY)} alt=""/>
                            {this.getI18nText(MY_I18N_KEYS.forums_dropdown_header_label)}
                          </label>
                        </button>
                        <button 
                          onClick={() => this.toggleShowTruescopeForumDropdown()}
                          className="dropdown-button"
                        >
                          <i className={`la la-${showTruescopeForumDropdown ? 'minus' :'plus'}`} />
                        </button>
                      </div>

                      {showTruescopeForumDropdown && (<div className="dropdown-source-pages-container">
                        {!sources.sourcesData.length && <Loader />}
                        {sources.truescopeForumSources.length > 0 &&
                          sources.truescopeForumSources.map((sourceData, index) => (
                            <div className="select-item"  key={'forum_' + index}>
                              <Input
                                className="styled-checkbox"
                                id={sourceData.sourceName}
                                type="checkbox"
                                onChange={() => this.setSourceStatus(sourceData.sourceName)}
                                checked={sourceData.selected}
                                value={sourceData.sourceName}
                              />
                              <label htmlFor={sourceData.sourceName}>
                                <img src={this._getFeedIcon(sourceData.sourceName)} alt=""/>
                                {sourceData.sourceName}
                              </label>
                            </div>
                          ))}
                      </div>)}
                    </div>)}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    sources: state.sources,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default withFirebase(connect(mapStateToProps, mapDispatchToProps)(Sources));



// WEBPACK FOOTER //
// ./src/features/sources/Sources.js